import Tools from './tools'
import Jobs from './jobs'
import DynamicJob from './jobs/dynamic_job'
import Cookies from './cookie'
import AdminPage from './admin'
import UserProfile from './profile'
import JobDetailsPage from './jobs/single'
import ToolDetailsPage from './tools/single'
import NewToolPage from './tools/new'
import AddFilePage from './uemail/add_email'
import FullBuildPage from './uemail/full_build'
import EditToolPage from './tools/edit'
import JobTaskDetailsPage from './jobs/single/job_task_details'
import TitlesPage from './titles'
import TLR from './tlr'

/**
 * Dashboard routes
 */
const routes = [
    {
        key: 'tools_page',
        path: '/dashboard',
        component: Tools,
        exact: true
    },
    {
        key: 'tool_details',
        path: '/dashboard/tool',
        component: ToolDetailsPage,
        exact: true
    },
    {
        key: 'tool_new',
        path: '/dashboard/tool/new',
        component: NewToolPage,
        exact: true
    },
    {
        key: 'tool_edit',
        path: '/dashboard/tool/edit',
        component: EditToolPage,
        exact: true
    },
    {
        key: 'jobs_page',
        path: '/dashboard/jobs',
        component: Jobs,
        exact: true
    },
    {
        key: 'jobs_task_detail',
        path: '/dashboard/job/task/details',
        component: JobTaskDetailsPage,
        exact: true
    },
    {
        key: 'admin_page',
        path: '/dashboard/admin',
        component: AdminPage,
        exact: true
    },
    {
        key: 'profile_page',
        path: '/dashboard/profile',
        component: UserProfile,
        exact: true
    },
    {
        key: 'job_details',
        path: '/dashboard/job',
        component: JobDetailsPage,
        exact: true
    },
    {
        key: 'add_file',
        path: '/dashboard/uemail/add-file',
        component: AddFilePage,
        exact: true
    },
    {
        key: 'full_build',
        path: '/dashboard/uemail/full-build',
        component: FullBuildPage,
        exact: true
    },
    {
        key: 'dynamic_job',
        path: '/dashboard/dynamic-job',
        component: DynamicJob,
        exact: true
    },
    {
        key: 'cookies',
        path: '/dashboard/cookies',
        component: Cookies,
        exact: true
    },
    {
        key: 'tlr',
        path: '/dashboard/tlr',
        component: TLR,
        exact: true
    },
    {
        key: 'titles',
        path: '/dashboard/titles',
        component: TitlesPage,
        exact: true
    },
]

export default routes
